import PropTypes from 'prop-types'
import React, { PureComponent } from 'react'
import { Link, browserHistory } from 'react-router'
import classnames from 'classnames'
import ImmutableProptypes from 'react-immutable-proptypes'
import { Map } from 'immutable'
import ReactTooltip from 'react-tooltip'
import Modal from 'react-modal'

import CategoryTabs from '_components/categoryTabs'
import TaskForm from '_components/categoryTabs/taskForm'
import ThoughtsForm from '_components/categoryTabs/thoughtsForm'
import EmotionForm from '_components/categoryTabs/emotionsForm'
import EngagementForm from '_components/categoryTabs/engagementForm'
import Socket from '_utils/socket'
import { USER_STATUS_TYPES } from '_utils/userStatusType'
import LOGO from '_images/logo.png'

import styles from './styles.css'

class Header extends PureComponent {
  static propTypes = {
    className: PropTypes.string,
    user: ImmutableProptypes.map,
    logout: PropTypes.func,
  }

  static defaultProps = {
    className: null,
    user: new Map(),
    logout: () => {},
  }

  state = {
    openPlusForm: false,
    openSearch: false,
    queryString: '',
  }

  onClick = event => {
    const { name } = event.currentTarget
    if (name === 'logout') {
      event.preventDefault()
      Socket.emit('changeUserStatus', USER_STATUS_TYPES.INACTIVE)
      this.props.logout()
      browserHistory.push('/login')
    }
  }

  onKeyPress = event => {
    if (event.key === 'Enter') {
      this.handleSearchPress()
    }
  }

  handleSearchPress = () => {
    const { queryString } = this.state

    if (!queryString) return

    browserHistory.push({
      pathname: '/search',
      search: `?queryString=${queryString}`,
    })
    this.closeSearch()
  }

  onInputChange = e => {
    const { id, value } = e.target
    this.setState({ [id]: value })
  }

  add = () => {
    this.setState({ openPlusForm: true })
  }

  closePlusForm = () => {
    this.setState({ openPlusForm: false })
  }

  openSearch = () => {
    this.setState({ openSearch: true })
  }

  closeSearch = () => {
    this.setState({ openSearch: false, queryString: '' })
  }

  render() {
    const { openPlusForm, openSearch, queryString } = this.state
    const { className, user } = this.props
    const loggedIn = !!user.get('token')
    const name = user.get('name') ? user.get('name') : ''
    const dynamicHeaderItems = user.get('token')
      ? [
          {
            title: 'LOGOUT',
            link: '/logout',
            key: 'logout',
          },
        ]
      : [
          {
            title: 'LOGIN',
            link: '/login',
            key: 'login',
          },
          {
            title: 'SIGN UP',
            link: '/sign-up',
            key: 'signup',
          },
        ]

    return (
      <header className={classnames(className, styles.header)}>
        <div data-tip data-for="version-tip">
          <img className={styles.logo} src={LOGO} alt="" />
          <ReactTooltip id="version-tip">1.3.7</ReactTooltip>
        </div>
        {!loggedIn ? (
          <div className={styles.buttonContainer}>
            {dynamicHeaderItems.map(({ title, link, key }) => (
              <Link key={key} name={key} to={link} className={styles.button} onClick={this.onClick}>
                {title}
              </Link>
            ))}
          </div>
        ) : (
          <div className={styles.iconsContainer}>
            {openSearch ? (
              <div className={styles.searchBoxContainer}>
                <input
                  type="text"
                  autoFocus
                  id="queryString"
                  onBlur={this.closeSearch}
                  style={{ margin: 0, border: 0 }}
                  value={queryString}
                  onChange={this.onInputChange}
                  onKeyPress={this.onKeyPress}
                />
                <i className={classnames('fa fa-search', styles.icon)} />
              </div>
            ) : (
              <div className={styles.iconLink} onClick={this.openSearch}>
                <i className={classnames('fa fa-search', styles.icon)} />
              </div>
            )}

            <div className={styles.iconLink}>
              <i
                data-tip
                data-for="add-form-tip"
                className={classnames('fa fa-plus-circle', styles.icon)}
                onClick={this.add}
                style={{ color: '#778EFF', fontSize: 24, cursor: 'pointer' }}
              >
                <ReactTooltip id="add-form-tip">Add Form</ReactTooltip>
              </i>
            </div>

            <Link key="log" name="log" to="/log" className={styles.iconLink}>
              <i data-tip data-for="log-tip" className={classnames('fa fa-book', styles.icon)}>
                <ReactTooltip id="log-tip">Log</ReactTooltip>
              </i>
            </Link>
            <Link key="settings" name="settings" to="/settings" className={styles.iconLink}>
              <i
                data-tip
                data-for="settings-tip"
                className={classnames('fa fa-cog', styles.icon)}
                style={{ fontSize: 23 }}
              >
                <ReactTooltip id="settings-tip">Settings</ReactTooltip>
              </i>
            </Link>
            {this.props.user.get('isAdmin', false) && (
              <Link key="admin" name="admin" to="/admin" className={styles.iconLink}>
                <i
                  data-tip
                  data-for="admin-tip"
                  className={classnames('fa fa-diamond', styles.icon)}
                >
                  <ReactTooltip id="admin-tip">Admin</ReactTooltip>
                </i>
              </Link>
            )}

            <Link
              key="logout"
              name="logout"
              to="/logout"
              className={styles.iconLink}
              onClick={this.onClick}
            >
              <i
                data-tip
                data-for="logout-tip"
                className={classnames('fa fa-sign-out', styles.icon)}
                style={{ fontSize: 25 }}
              >
                <ReactTooltip id="logout-tip">Logout</ReactTooltip>
              </i>
            </Link>
            <Link key="profile" name="profile" to="/profile" className={styles.name}>
              <i
                data-tip
                data-for="profile-tip"
                className={classnames('fa fa-user-circle', styles.icon)}
              >
                <ReactTooltip id="profile-tip">Profile</ReactTooltip>
              </i>
              <div className={styles.nameText}>
                Hello Mindful {name.charAt(0).toUpperCase() + name.slice(1)}
              </div>
            </Link>
          </div>
        )}

        <Modal
          isOpen={openPlusForm}
          className={classnames(styles.modal)}
          overlayClassName={classnames(styles.overlay)}
          bodyOpenClassName={classnames(styles['disable-body-scroll'])}
          onRequestClose={this.closePlusForm}
        >
          <CategoryTabs isOpen={openPlusForm} closePlusForm={this.closePlusForm}>
            <TaskForm displayError={this.props.displayError} />
            <ThoughtsForm displayError={this.props.displayError} />
            <EmotionForm displayError={this.props.displayError} />
            <EngagementForm displayError={this.props.displayError} />
          </CategoryTabs>
        </Modal>
      </header>
    )
  }
}

export default Header



// WEBPACK FOOTER //
// ./src/components/header/index.js